import  React, {
        }                                   from "react";
import Style                                from "components/UI/main.module.scss";

export const LabelModule           = ({value}) => {
    let     label                 = null;
    const   Mithrandir            = {
        A: "Reitor",
        B: "Pessoas e Organização",
        C: "Administrador",
        D: "Comum",
    };
    try {
        label = Mithrandir[`${value}`];
    }
    catch(e) {
        console.error(e);
        return null;
    }        
    return(
        label && (
            <span>                    
                {label} 
            </span>
        )
    );
};
export const IconHistory           = ({Boolean}) => {
    if(!Boolean) 
        return (
            <div className={[Style.d_flex, Style.align_itens_center, Style.justify_content_center].join(" ")}>
                <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="20" height="20">
                    <defs>
                        <linearGradient id="xmarkGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%"    stopColor="rgb(211, 47, 47)" />
                            <stop offset="80%"   stopColor="rgb(248, 113, 113)" />
                        </linearGradient>
                    </defs>
                    <path 
                        d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                        fill="url(#xmarkGradient)"
                    />
                </svg>
            </div>
        );
    return(
        <div className={[Style.d_flex, Style.align_itens_center, Style.justify_content_center].join(" ")}>
        {Boolean === true? 
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="20" height="20">
                <defs>
                    <linearGradient id="checkmarkGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%"    stopColor="rgb(46, 125, 50)" />
                        <stop offset="80%"   stopColor="rgb(74, 222, 128)" />
                    </linearGradient>
                </defs>
                <path 
                    d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"
                    fill="url(#checkmarkGradient)"
                />
            </svg>
        :
            <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="20" height="20">
                <defs>
                    <linearGradient id="xmarkGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%"    stopColor="rgb(211, 47, 47)" />
                        <stop offset="80%"   stopColor="rgb(248, 113, 113)" />
                    </linearGradient>
                </defs>
                <path 
                    d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                    fill="url(#xmarkGradient)"
                />
            </svg>
        }
        </div>
    );
};